export default __webpack_public_path__ + "static/media/8.9543f0ca.png";